import SPACER from '../spacer/index.js';

var GRID = {
  xsContentMaxWidth: '350px',
  smContentMaxWidth: '500px',
  xlContentMaxWidth: '1250px',
  standardPadding: SPACER.xlarge
};

export { GRID as default };
